export default __webpack_public_path__ + "static/style4.3_Andrey-9ca50534b9c603c236f710a0cb746f7a.wav";